// Libraries
import React from 'react';
import { useLazyQuery } from 'react-apollo';
import { get, join, capitalize } from 'lodash';
import { useHistory } from "react-router-dom";
import { loader } from 'graphql.macro';

// Config
import {
  ERROR_CONNECTION,
  MESSAGES_MAP
} from 'config';

// Types
import { SESSION_TYPE } from 'services/session';

// Data
import { COLUMNS, GET_ACTIONS_CELL } from './data';

// GraphQL
const odrevQuery = loader('src/graphql/queries/odrev.gql');

export type LIST_PROPS_TYPE = {
  session?: SESSION_TYPE,
  url: string
};

export const useList = ({
  session,
  url
}: LIST_PROPS_TYPE) => {
  const history = useHistory();
  const [data, setData] = React.useState([]);

  const columns = React.useMemo(
    () => COLUMNS,
    []
  );

  const [error, setError] = React.useState<string | boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  const [
    handleODREVQuery,
    {
      loading: odrevQueryLoading,
      data: odrevQueryData,
      error: odrevQueryError
    }] = useLazyQuery(odrevQuery, {
    fetchPolicy: 'no-cache'
  });

  const token = get(session, 'token');

  React.useEffect(() => {
    setLoading(!!odrevQueryLoading);
  }, [odrevQueryLoading]);

  React.useEffect((): any => {
    !!token && handleODREVQuery();
  },[token]);

  React.useEffect((): any => {
    if (!odrevQueryData || odrevQueryLoading) {
      return;
    }
    const isError = get(odrevQueryData, 'odrev.__typename') === 'Error';
    const message = get(odrevQueryData, 'odrev.message');
    const normalizedData = get(odrevQueryData, 'odrev.data', []).map((odrev: object) => ({
      ...odrev,
      client: `${get(odrev, 'client.surname', '')} ${capitalize(get(odrev, 'client.name', '').substr(0,1))}. ${capitalize(get(odrev, 'client.patronymic', '').substr(0,1))}.`,
      actions: GET_ACTIONS_CELL({
        ...odrev,
        onEdit: () => history.push(`${url}/${get(odrev, 'id')}`),
      })
    }));

    const dataError = isError && get(MESSAGES_MAP, `${message}`, message);
    const currentErrors = [
      ...(odrevQueryError ? [ERROR_CONNECTION] : []),
      ...(dataError ? [dataError] : []),
    ];
    currentErrors.length > 0 ? setError(join(currentErrors, '\n')) : setData(normalizedData);

  }, [odrevQueryData]);

  return {
    loading,
    error,
    data,
    columns,
  };
};

export default useList;
